import { render, staticRenderFns } from "./RiskCategory.vue?vue&type=template&id=337c7c0b&scoped=true&"
import script from "./RiskCategory.vue?vue&type=script&lang=js&"
export * from "./RiskCategory.vue?vue&type=script&lang=js&"
import style0 from "./RiskCategory.vue?vue&type=style&index=0&id=337c7c0b&lang=scss&scoped=true&"
import style1 from "./RiskCategory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337c7c0b",
  null
  
)

export default component.exports